import {filter, Subject, take, tap} from 'rxjs';
import store from '@/store';

class SubjectUtils {

    /**
     * This is method part of the generalisation between multiple views (datatable, formular, ...)
     *
     * The subject referenced via first param is subscribed until the filter condition matches.
     * Once the filter condition matches, we process only the first call.
     *
     * If the request takes longer than 10 seconds, we show the user a message, that he should hold on.
     */
    public delayUntilSubjectMatchesFilterConditionOnce<T extends any>(
        subject: Subject<T>,
        filterCondition: (currentVal: T) => boolean,
        positiveCb: () => void,
        negativeCb: () => void
    ) {
        let requestsTakeLongerThanExpectedTimeout: number | null = null;
        subject.pipe(
            tap(() => {
                if (requestsTakeLongerThanExpectedTimeout == null) {
                    requestsTakeLongerThanExpectedTimeout = setTimeout(() => {
                        store.commit('showSnack', {
                            message: 'Die Anfrage dauert länger als erwartet. Bitte warten Sie.',
                            color: 'warn'
                        });
                    }, 10000);
                }
            }),
            filter(filterCondition),
            take(1), // first matching 0
            tap(() => {
                if (requestsTakeLongerThanExpectedTimeout != null) {
                    clearTimeout(requestsTakeLongerThanExpectedTimeout);
                }
            })
        ).subscribe({
            next: positiveCb,
            error: negativeCb
        });
    }

}

const SUBJECT_UTILS_INSTANCE = new SubjectUtils();

export {SUBJECT_UTILS_INSTANCE};
